import { Box, Text } from '@chakra-ui/react';

export const NotFoundSuggestionList = () => {
  return (
    <Box data-testid="not-found-suggestion-list" pt="10%">
      <Text textAlign="center" mt={8} fontWeight={600}>
        No results found
      </Text>
      <Text textAlign="center" mt={2}>
        You can also type an email to invite collaborators
      </Text>
    </Box>
  );
};
